import { alpha } from '@mui/material/styles';
import { spacing } from 'studio/helpers';

export default {
  icon: {
    width: 25,
    marginLeft: 2,
    marginRight: 2
  },
  logo: {
    width: 72,
    height: 'initial',
    marginRight: '6px',
    marginBottom: '-1px'
  },
  title: {
    fontSize: 22,
    display: 'flex',
    alignItems: 'center',
    color: 'common.white',
    '& span': {
      marginTop: '-2px'
    }
  },
  buttons: {
    '& .MuiLink-root': {
      color: 'common.white'
    }
  },
  appBar: theme => ({
    zIndex: theme.zIndex.drawer + 1,
    '& .MuiToolbar-root': {
      paddingLeft: 0,
      paddingRight: 2
    },
    '& .MuiGrid-item': {
      display: 'flex',
      alignItems: 'center'
    }
  }),
  button: theme => ({
    textTransform: 'none',
    background: 'none',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, theme.palette.action.selectedOpacity + 0.1),
      color: '#ffffff'
    },
    fontSize: 13,
    paddingLeft: 1.5,
    paddingRight: 1.5,
    marginRight: 1,
    '& .MuiSvgIcon-root': {
      height: 20,
      marginRight: 1
    }
  }),
  card: {
    width: 250,
    '& .MuiCardHeader-root': {
      paddingBottom: 0
    },
    '& .MuiCardHeader-content': {
      overflow: 'hidden'
    },
    '& .MuiCardHeader-subheader': {
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    },
    '& .MuiCardContent-root': {
      paddingLeft: 1,
      paddingRight: 1,
      paddingBottom: 1
    }
  },
  drawer: theme => ({
    // the 'spacing' function returns a string with a 'px' suffix
    width: theme.drawerWidth + spacing(theme, 3.5)
  })
};
